import { useState, useEffect } from "react";
import TakeayaCompanySection from "./components/Other";
import { Link } from "react-router";
import logo from "../src/white-logo.png";
import blackLogo from "../src/black-logo.png";

import img1 from "./images/header-img-1.jpeg";
import img2 from "./images/header-img-2.jpeg";
import img3 from "./images/header-img-3.jpeg";

const TakeayaComponent = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Handle scroll for navbar effects
  useEffect(() => {
    const handleScroll = () => {
      const position = window.scrollY;
      setScrollPosition(position);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    // Call once to set initial position
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Animate elements on mount
  useEffect(() => {
    setIsVisible(true);
  }, []);

  // Toggle mobile menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const images = [img3, img2, img1];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Function to move to the next slide
  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  // Auto-advance slides every 5 seconds
  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white overflow-hidden font-ivyMode">
      <section className="relative overflow-hidden bg-black">
        {/* Background Panoramic Image Slider with Ken Burns Effect */}
        <div className="absolute inset-0 z-0">
          {/* Premium Overlay with Custom Gradient and Texture */}
          <div className="absolute inset-0 bg-gradient-to-br from-black/90 via-black/70 to-primary/30 z-10 mix-blend-multiply"></div>

          {/* Subtle Texture Overlay */}
          <div
            className="absolute inset-0 z-5 opacity-10 mix-blend-overlay"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23a3582a' fill-opacity='0.4' fill-rule='evenodd'%3E%3Ccircle cx='3' cy='3' r='1'/%3E%3Ccircle cx='13' cy='13' r='1'/%3E%3C/g%3E%3C/svg%3E")`,
              backgroundSize: "7px 7px",
            }}
          ></div>

          {/* Advanced Ken Burns Effect Image Slider - Responsive Background Images */}
          <div className="image-panorama-slider h-full">
            <div
              className="slider-image ken-burns-zoom"
              style={{
                backgroundImage: `url("${images[0]}")`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                animation:
                  "kenBurns 20s ease-out infinite alternate, fadeSlide1 30s infinite",
              }}
            ></div>

            <div
              className="slider-image ken-burns-pan"
              style={{
                backgroundImage: `url("${images[1]}")`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                animation:
                  "kenBurnsPan 25s ease-out infinite alternate, fadeSlide2 30s infinite",
              }}
            ></div>

            <div
              className="slider-image ken-burns-reveal"
              style={{
                backgroundImage: `url("${images[2]}")`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                animation:
                  "kenBurnsReveal 22s ease-out infinite alternate, fadeSlide3 30s infinite",
              }}
            ></div>
          </div>
        </div>

        {/* Dynamic Particle Effect Overlay */}
        <div className="absolute inset-0 z-5 particle-container">
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <div className="particle particle-4"></div>
          <div className="particle particle-5"></div>
          <div className="particle particle-6"></div>
          <div className="particle particle-7"></div>
          <div className="particle particle-8"></div>
        </div>

        {/* Luxurious Vertical Line Accents - Hidden on mobile */}
        <div className="absolute top-0 left-1/3 h-full w-px bg-gradient-to-b from-transparent via-secondary/20 to-transparent z-5 hidden md:block"></div>
        <div className="absolute top-0 right-1/3 h-full w-px bg-gradient-to-b from-transparent via-primary/20 to-transparent z-5 hidden md:block"></div>

        <div className="fixed top-0 left-0 w-full z-50">
          <div
            className={`transition-all duration-300 border-b ${
              scrolled
                ? "bg-white border-gray-200"
                : "bg-transparent border-transparent"
            }`}
          >
            <div className="container mx-auto px-4 sm:px-6 py-4">
              <div className="flex justify-between items-center">
                <div className="text-xl sm:text-2xl font-serif tracking-wider flex items-center">
                  <Link to='/'>
                  <img
                    src={scrolled ? blackLogo : logo}
                    alt="La Passion"
                    className="h-12 md:h-16"
                  />
                  </Link>
                </div>

                {/* Desktop Navigation */}
                <div className="hidden md:flex items-center space-x-4 lg:space-x-8">
                  <Link
                    to="/"
                    className={`bg-secondary text-white py-1 px-2 rounded-md transition-colors text-sm uppercase tracking-wider`}
                  >
                    Home
                  </Link>
                  <Link
                    to="/properties"
                    className={`${
                      scrolled ? "text-secondary" : "text-white"
                    } hover:bg-secondary hover:text-white py-1 px-2 rounded-md transition-colors text-sm uppercase tracking-wider`}
                  >
                    Properties
                  </Link>
                  <Link
                    to="/services"
                    className={`${
                      scrolled ? "text-secondary" : "text-white"
                    } hover:bg-secondary hover:text-white py-1 px-2 rounded-md transition-colors text-sm uppercase tracking-wider`}
                  >
                    Services
                  </Link>
                  <Link
                    to="/contact"
                    className={`${
                      scrolled ? "text-secondary" : "text-white"
                    } hover:bg-secondary hover:text-white py-1 px-2 rounded-md transition-colors text-sm uppercase tracking-wider`}
                  >
                    Contact
                  </Link>
                </div>

                {/* Mobile Menu Button */}
                <button
                  className={`md:hidden ${
                    scrolled ? "text-secondary" : "text-white"
                  } focus:outline-none`}
                  onClick={toggleMenu}
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d={
                        isMenuOpen
                          ? "M6 18L18 6M6 6l12 12"
                          : "M4 6h16M4 12h16M4 18h16"
                      }
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {/* Mobile Menu Dropdown */}
          <div
            className={`md:hidden bg-black/95 backdrop-blur-md transition-all duration-300 overflow-hidden ${
              isMenuOpen ? "max-h-96 border-b border-white/10" : "max-h-0"
            }`}
          >
            <div className="container mx-auto px-6 py-4">
              <div className="flex flex-col space-y-4">
                <Link
                  to="/"
                  className="text-white/90 hover:text-secondary transition-colors text-sm uppercase tracking-wider py-2"
                >
                  Home
                </Link>
                <Link
                  to="/properties"
                  className="text-white/90 hover:text-secondary transition-colors text-sm uppercase tracking-wider py-2"
                >
                  Properties
                </Link>
                <Link
                  to="/services"
                  className="text-white/90 hover:text-secondary transition-colors text-sm uppercase tracking-wider py-2"
                >
                  Services
                </Link>
                <Link
                  to="/contact"
                  className="text-white/90 hover:text-secondary transition-colors text-sm uppercase tracking-wider py-2"
                >
                  Contact
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Main Hero Content with Parallax Effect */}
        <div className="relative min-h-screen flex flex-col justify-center pt-20 pb-32 z-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 w-full">
            <div className="grid lg:grid-cols-12 gap-6 md:gap-12 w-full items-center">
              {/* Left Text Content with Advanced Animations */}
              <div
                className="lg:col-span-6 text-left parallax-content"
                data-speed="0.85"
              >
                {/* Premium Status Badge */}
                <div className="inline-block px-4 sm:px-6 py-2 rounded-full mb-6 sm:mb-8 backdrop-blur-md bg-gradient-to-r from-secondary/20 to-secondary/20 border border-secondary/30 reveal-item">
                  <p className="font-ivyMode text-white text-xs sm:text-sm flex items-center">
                    <span className="w-2 h-2 bg-secondary rounded-full mr-2 pulse-animation"></span>
                    Premium Vacation Homes in Dubai
                  </p>
                </div>

                {/* Animated Heading with Staggered Reveal - Responsive Font Sizes */}
                <h1 className="text-4xl md:text-5xl lg:text-7xl text-white font-bold tracking-tight leading-none mb-4 sm:mb-6">
                  <span className="block reveal-heading">Discover</span>
                  <span className="block mt-1 reveal-heading delay-200">
                    <span className="relative inline-block">
                      <span className="absolute -rotate-2 bg-primary inset-0 rounded-md heading-background"></span>
                      <span className="relative text-white">Extraordinary</span>
                    </span>
                  </span>
                  <span className="block mt-1 reveal-heading delay-400 text-primary">
                    Living
                  </span>
                </h1>

                {/* Description with Reveal Animation - Responsive Font Sizes */}
                <p className="font-sans text-white/90 text-lg sm:text-xl md:text-2xl mb-6 sm:mb-10 max-w-xl text-left reveal-paragraph">
                  Takeaya curates exceptional properties that combine
                  sophisticated design, unparalleled comfort, and authentic
                  Arabian luxury for discerning guests.
                </p>

                {/* CTA Buttons - Responsive Layout */}
                <div className="flex flex-col sm:flex-row gap-4 sm:gap-5 md:gap-6 reveal-item delay-600">
                  <Link
                    to="/services"
                    className="font-sans relative overflow-hidden group px-6 sm:px-8 md:px-10 py-3 sm:py-4 md:py-5 rounded-full text-sm font-medium transition-all"
                  >
                    <span className="absolute inset-0 border-2 border-[#E4E2D5]/80 z-0 rounded-full"></span>
                    <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 rounded-full"></span>
                    <span className="relative z-20 text-white group-hover:text-primary transition-colors duration-300 flex items-center justify-center sm:justify-start">
                      Our Services
                      <span className="ml-2 transform group-hover:translate-x-1 transition-transform duration-300">
                        →
                      </span>
                    </span>
                  </Link>

                  <Link
                    to="/contact"
                    className="font-sans relative overflow-hidden group px-6 sm:px-8 md:px-10 py-3 sm:py-4 md:py-5 rounded-full text-sm font-medium transition-all"
                  >
                    <span className="absolute inset-0 border-2 border-[#E4E2D5]/80 z-0 rounded-full"></span>
                    <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 rounded-full"></span>
                    <span className="relative z-20 text-white group-hover:text-primary transition-colors duration-300 flex items-center justify-center sm:justify-start">
                      List Your Property
                      <span className="ml-2 transform group-hover:translate-x-1 transition-transform duration-300">
                        →
                      </span>
                    </span>
                  </Link>
                </div>
              </div>

              {/* Right Featured Property Showcase - Hidden on mobile, shown on desktop */}
              <div className="lg:col-span-6 hidden lg:block perspective-container">
                <div className="relative property-card-3d" data-speed="1.1">
                  {/* Main property image with premium frame */}
                  <div className="relative z-20 p-0.5 bg-gradient-to-br from-primary via-secondary to-[#8C8660] rounded-xl shadow-2xl overflow-hidden property-card-inner">
                    <div className="bg-black p-0.5 rounded-xl overflow-hidden">
                      <img
                        src={images[2]}
                        alt="Luxury Villa"
                        className="w-full h-full object-cover rounded-lg transform transition-transform property-image"
                      />

                      {/* Property info overlay with glass morphism */}
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/95 via-black/80 to-transparent backdrop-blur-sm p-8 transform translate-y-0 transition-transform duration-500 property-info">
                        <div>
                          <div className="flex justify-between items-center mb-2">
                            <Link
                              to="/properties"
                              className="font-sans relative overflow-hidden group px-6 sm:px-8 md:px-10 py-3 sm:py-4 md:py-5 rounded-full text-sm font-medium shadow-xl transition-all"
                            >
                              <span className="absolute inset-0 bg-gradient-to-r from-primary to-secondary z-0"></span>
                              <span className="absolute inset-0 bg-gradient-to-r from-secondary to-primary z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></span>
                              <span className="relative z-20 text-white flex items-center justify-center sm:justify-start">
                                Explore Properties
                                <svg
                                  className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                                  />
                                </svg>
                              </span>
                            </Link>
                            <div className="flex items-center">
                              {[...Array(5)].map((_, i) => (
                                <svg
                                  key={i}
                                  className="w-4 h-4 text-secondary"
                                  viewBox="0 0 24 24"
                                  fill="currentColor"
                                >
                                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                                </svg>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Feature cards - Only visible on large screens */}
                  <div className="absolute -left-16 bottom-40 bg-white/10 backdrop-blur-xl rounded-xl p-4 shadow-2xl z-30 max-w-xs border border-white/20 feature-card-1 hidden xl:flex">
                    <div className="flex items-center space-x-3">
                      <div className="w-12 h-12 bg-gradient-to-br from-primary/80 to-secondary/80 rounded-full flex items-center justify-center">
                        <svg
                          className="w-6 h-6 text-white"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Mobile Featured Property Card (simplified version for small screens) */}
              <div className="lg:hidden w-full mt-8">
                <div className="relative rounded-xl overflow-hidden shadow-lg">
                  <img
                    src={images[2]}
                    alt="Luxury Villa"
                    className="w-full h-64 object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 to-transparent"></div>

                  {/* Mobile property info overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <div className="flex justify-between items-center">
                      <div>
                        <h3 className="font-serif text-white text-xl mb-1">
                          Family-Friendly Spaces
                        </h3>
                        <div className="flex items-center mb-2">
                          {[...Array(5)].map((_, i) => (
                            <svg
                              key={i}
                              className="w-3 h-3 text-secondary"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                            >
                              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                            </svg>
                          ))}
                        </div>
                      </div>
                      <div className="text-secondary font-bold text-lg">
                        $1,400
                        <span className="text-xs text-white/70 font-normal">
                          /night
                        </span>
                      </div>
                    </div>

                    <div className="flex justify-between mt-2">
                      <div className="flex space-x-2">
                        <div className="flex items-center text-white text-xs">
                          <svg
                            className="w-4 h-4 text-secondary mr-1"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                          </svg>
                          8
                        </div>
                        <div className="flex items-center text-white text-xs">
                          <svg
                            className="w-4 h-4 text-secondary mr-1"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z" />
                          </svg>
                          4
                        </div>
                        <div className="flex items-center text-white text-xs">
                          <svg
                            className="w-4 h-4 text-secondary mr-1"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M7 19c-1.1 0-2 .9-2 2h14c0-1.1-.9-2-2-2h-4v-2h3c1.1 0 2-.9 2-2h-8c-1.66 0-3-1.34-3-3 0-1.09.59-2.04 1.46-2.56C8.17 9.03 8 8.54 8 8c0-.21.04-.42.09-.62C6.28 8.13 5 9.92 5 12c0 2.76 2.24 5 5 5v2H7z" />
                          </svg>
                          Pool
                        </div>
                      </div>
                       <Link
                              to="/properties"
                              className="font-sans relative overflow-hidden group px-6 sm:px-8 md:px-10 py-3 sm:py-4 md:py-5 rounded-full text-sm font-medium shadow-xl transition-all"
                            >
                              <span className="absolute inset-0 bg-gradient-to-r from-primary to-secondary z-0"></span>
                              <span className="absolute inset-0 bg-gradient-to-r from-secondary to-primary z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></span>
                              <span className="relative z-20 text-white flex items-center justify-center sm:justify-start">
                                Explore Properties
                                <svg
                                  className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                                  />
                                </svg>
                              </span>
                            </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Scroll Indicator - Hide on small screens */}
          <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 z-20 flex-col items-center hidden md:flex">
            <div className="text-xs uppercase tracking-widest text-white/60 mb-2">
              Scroll to explore
            </div>
            <div className="w-6 h-10 border-2 border-white/20 rounded-full flex justify-center p-1">
              <div className="w-1 h-2 bg-secondary rounded-full animate-scroll-down"></div>
            </div>
          </div>
        </div>

        {/* Custom CSS Animations */}
        <style jsx>{`
          /* Advanced Image Slider with Ken Burns Effect */
          .image-panorama-slider {
            position: relative;
            height: 100%;
            width: 100%;
            overflow: hidden;
          }

          .slider-image {
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
          }

          @keyframes kenBurns {
            0% {
              transform: scale(1.2);
            }
            100% {
              transform: scale(1);
            }
          }

          @keyframes kenBurnsPan {
            0% {
              transform: scale(1.2) translate(-2%, 0);
            }
            100% {
              transform: scale(1) translate(2%, 0);
            }
          }

          @keyframes kenBurnsReveal {
            0% {
              transform: scale(1);
            }
            100% {
              transform: scale(1.15);
            }
          }

          @keyframes fadeSlide1 {
            0%,
            27% {
              opacity: 1;
            }
            33%,
            93% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }

          @keyframes fadeSlide2 {
            0%,
            27% {
              opacity: 0;
            }
            33%,
            60% {
              opacity: 1;
            }
            66%,
            100% {
              opacity: 0;
            }
          }

          @keyframes fadeSlide3 {
            0%,
            60% {
              opacity: 0;
            }
            66%,
            93% {
              opacity: 1;
            }
            100% {
              opacity: 0;
            }
          }

          /* Floating Particle Animation */
          .particle-container {
            overflow: hidden;
            pointer-events: none;
          }

          .particle {
            position: absolute;
            border-radius: 50%;
            background: radial-gradient(
              circle at center,
              rgba(233, 186, 103, 0.8),
              rgba(233, 186, 103, 0)
            );
            animation-timing-function: cubic-bezier(0.2, 0.3, 0.8, 0.7);
            animation-iteration-count: infinite;
            opacity: 0;
          }

          /* Adjust particle sizes for mobile */
          @media (max-width: 768px) {
            .particle {
              transform: scale(0.7);
            }
          }

          .particle-1 {
            width: 80px;
            height: 80px;
            left: 10%;
            top: 20%;
            animation: floatParticle 15s 0s infinite;
          }

          .particle-2 {
            width: 60px;
            height: 60px;
            left: 85%;
            top: 15%;
            animation: floatParticle 18s 2s infinite;
          }

          .particle-3 {
            width: 100px;
            height: 100px;
            left: 20%;
            top: 70%;
            animation: floatParticle 20s 1s infinite;
          }

          .particle-4 {
            width: 40px;
            height: 40px;
            left: 65%;
            top: 80%;
            animation: floatParticle 12s 3s infinite;
          }

          .particle-5 {
            width: 120px;
            height: 120px;
            left: 50%;
            top: 30%;
            animation: floatParticle 25s 2s infinite;
          }

          .particle-6 {
            width: 30px;
            height: 30px;
            left: 30%;
            top: 40%;
            animation: floatParticle 10s 4s infinite;
          }

          .particle-7 {
            width: 70px;
            height: 70px;
            left: 75%;
            top: 55%;
            animation: floatParticle 16s 0s infinite;
          }

          .particle-8 {
            width: 90px;
            height: 90px;
            left: 15%;
            top: 85%;
            animation: floatParticle 22s 3s infinite;
          }

          @keyframes floatParticle {
            0% {
              transform: translate(0, 0);
              opacity: 0;
            }
            25% {
              opacity: 0.3;
            }
            50% {
              transform: translate(20px, -30px);
              opacity: 0.1;
            }
            75% {
              opacity: 0.2;
            }
            100% {
              transform: translate(0, 0);
              opacity: 0;
            }
          }

          /* 3D Property Card Effect */
          .perspective-container {
            perspective: 1000px;
          }

          .property-card-3d {
            transform-style: preserve-3d;
            transition: transform 0.5s ease;
          }

          .property-card-3d:hover {
            transform: rotateY(-5deg) rotateX(5deg);
          }

          .property-card-3d:hover .property-card-inner {
            box-shadow: 0 30px 60px rgba(0, 0, 0, 0.5);
          }

          .property-card-3d:hover .property-image {
            transform: scale(1.05);
          }

          .feature-card-1 {
            transform: translateZ(20px) rotate(-3deg);
            animation: floatCard 8s ease-in-out infinite;
          }

          .feature-card-2 {
            transform: translateZ(30px) rotate(3deg);
            animation: floatCard 8s ease-in-out infinite 1s;
          }

          .status-badge {
            transform: translateZ(40px);
            animation: pulseScale 3s infinite;
          }

          .virtual-tour-badge {
            transform: translateZ(25px);
            animation: pulseOpacity 4s infinite ease-in-out;
          }

          @keyframes floatCard {
            0%,
            100% {
              transform: translateZ(20px) translateY(0) rotate(-3deg);
            }
            50% {
              transform: translateZ(20px) translateY(-10px) rotate(-3deg);
            }
          }

          @keyframes pulseScale {
            0%,
            100% {
              transform: translateZ(40px) scale(1);
            }
            50% {
              transform: translateZ(40px) scale(1.1);
            }
          }

          @keyframes pulseOpacity {
            0%,
            100% {
              opacity: 0.8;
            }
            50% {
              opacity: 1;
            }
          }

          /* Glow Effects */
          .glow-effect {
            animation: glowPulse 3s infinite;
          }

          @keyframes glowPulse {
            0%,
            100% {
              opacity: 0.8;
              box-shadow: 0 0 10px rgba(233, 186, 103, 0.5);
            }
            50% {
              opacity: 1;
              box-shadow: 0 0 20px rgba(233, 186, 103, 0.8),
                0 0 30px rgba(163, 88, 42, 0.6);
            }
          }

          /* Staggered Content Reveal Animations */
          .reveal-item {
            opacity: 0;
            animation: revealUp 0.8s ease-out forwards;
          }

          .delay-200 {
            animation-delay: 0.2s;
          }

          .delay-400 {
            animation-delay: 0.4s;
          }

          .delay-600 {
            animation-delay: 0.6s;
          }

          .delay-800 {
            animation-delay: 0.8s;
          }

          .reveal-heading {
            opacity: 0;
            animation: revealLeft 0.8s ease-out forwards;
          }

          .heading-background {
            animation: drawBackground 0.5s ease-out forwards 0.3s;
            width: 0;
          }

          .reveal-paragraph {
            opacity: 0;
            animation: revealUp 0.8s ease-out forwards 0.4s;
          }

          @keyframes revealUp {
            from {
              transform: translateY(30px);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }

          @keyframes revealLeft {
            from {
              transform: translateX(-30px);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }

          @keyframes drawBackground {
            from {
              width: 0;
            }
            to {
              width: 100%;
            }
          }

          /* Parallax Effect */
          .parallax-content {
            will-change: transform;
          }

          /* Counter Animation */
          .counter-icon {
            position: relative;
          }

          .counter-icon::after {
            content: "";
            position: absolute;
            inset: -5px;
            border-radius: 50%;
            background: linear-gradient(
              45deg,
              rgba(163, 88, 42, 0.4),
              rgba(233, 186, 103, 0.4)
            );
            z-index: -1;
            animation: rotatePulse 3s linear infinite;
          }

          @keyframes rotatePulse {
            0% {
              transform: rotate(0deg);
              opacity: 0.6;
            }
            50% {
              opacity: 1;
            }
            100% {
              transform: rotate(360deg);
              opacity: 0.6;
            }
          }

          /* Scroll Indicator */
          @keyframes animate-scroll-down {
            0%,
            100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(6px);
            }
          }

          .animate-scroll-down {
            animation: animate-scroll-down 1.5s ease-in-out infinite;
          }

          /* Trust Metrics Animation */
          .trust-metrics {
            position: relative;
            overflow: hidden;
          }

          .trust-metrics::after {
            content: "";
            position: absolute;
            top: -50%;
            left: -50%;
            width: 200%;
            height: 200%;
            background: radial-gradient(
              ellipse at center,
              rgba(233, 186, 103, 0.1) 0%,
              rgba(0, 0, 0, 0) 70%
            );
            animation: rotateGradient 15s linear infinite;
          }

          @keyframes rotateGradient {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }

          /* Mobile specific animations */
          @media (max-width: 768px) {
            .staggered-title {
              font-size: smaller;
            }

            .reveal-heading,
            .reveal-paragraph,
            .reveal-item {
              animation-duration: 0.6s; /* Faster animations on mobile */
            }
          }
        `}</style>

        {/* JavaScript for Animations and Interactions */}
        <script
          dangerouslySetInnerHTML={{
            __html: `
      document.addEventListener('DOMContentLoaded', function() {
        // Parallax effect - adjust for mobile
        window.addEventListener('scroll', function() {
          // Skip parallax on mobile for better performance
          if (window.innerWidth > 768) {
            const scrollTop = window.pageYOffset;
            const parallaxElements = document.querySelectorAll('[data-speed]');
            
            parallaxElements.forEach(element => {
              const speed = parseFloat(element.getAttribute('data-speed')) || 1;
              element.style.transform = 'translateY(' + (scrollTop * (1 - speed)) + 'px)';
            });
          }
        });
        
        // Mobile menu functionality
        const menuButton = document.querySelector('.md\\:hidden.text-white');
        const mobileMenu = document.querySelector('.md\\:hidden.bg-black\\/95');
        
        if (menuButton) {
          menuButton.addEventListener('click', function() {
            if (mobileMenu.classList.contains('max-h-0')) {
              mobileMenu.classList.remove('max-h-0');
              mobileMenu.classList.add('max-h-96');
            } else {
              mobileMenu.classList.remove('max-h-96');
              mobileMenu.classList.add('max-h-0');
            }
          });
        }
        
        // Animated counters
        const startCounters = () => {
          const counters = document.querySelectorAll('.counter-value');
          const speed = 200;
          
          counters.forEach(counter => {
            const parent = counter.closest('.counter-number');
            const target = parseInt(parent.getAttribute('data-target'), 10);
            const inc = target / speed;
            let count = 0;
            
            const updateCount = () => {
              if (count < target) {
                count += inc;
                counter.innerText = Math.ceil(count);
                setTimeout(updateCount, 1);
              } else {
                counter.innerText = target;
              }
            };
            
            updateCount();
          });
        };
        
        // Initialize counters when they come into view
        const observerOptions = {
          threshold: 0.5
        };
        
        // Use IntersectionObserver if supported
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                startCounters();
                observer.unobserve(entry.target);
              }
            });
          }, observerOptions);
          
          const trustMetrics = document.querySelector('.trust-metrics');
          if (trustMetrics) {
            observer.observe(trustMetrics);
          }
        } else {
          // Fallback for browsers that don't support IntersectionObserver
          startCounters();
        }
        
        // 3D card rotation effect - only for desktop
        const card = document.querySelector('.property-card-3d');
        
        if (card && window.innerWidth > 1024) {
          card.addEventListener('mousemove', e => {
            const cardRect = card.getBoundingClientRect();
            const cardCenterX = cardRect.left + cardRect.width / 2;
            const cardCenterY = cardRect.top + cardRect.height / 2;
            const mouseX = e.clientX - cardCenterX;
            const mouseY = e.clientY - cardCenterY;
            
            // Calculate rotation values based on mouse position
            const rotateY = (mouseX / cardRect.width) * 10; // max 10 degrees
            const rotateX = (mouseY / cardRect.height) * -10; // max 10 degrees
            
            card.style.transform = \`rotateY(\${rotateY}deg) rotateX(\${rotateX}deg)\`;
          });
          
          card.addEventListener('mouseleave', () => {
            card.style.transform = 'rotateY(0) rotateX(0)';
          });
        }
      });
    `,
          }}
        />
      </section>

      {/* Mobile Optimized Company Section */}
      <TakeayaCompanySection />
    </div>
  );
};

export default TakeayaComponent;
